/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Sec_Pg_F2_QInputs */

const en_mk_sec_pg_f2_q = /** @type {(inputs: Mk_Sec_Pg_F2_QInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Who on your side can read our data?`)
};

const id_mk_sec_pg_f2_q = /** @type {(inputs: Mk_Sec_Pg_F2_QInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Siapa saja yang bisa membaca data kami dari pihak Anda?`)
};

/**
* | output |
* | --- |
* | "Who on your side can read our data?" |
*
* @param {Mk_Sec_Pg_F2_QInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_sec_pg_f2_q = /** @type {((inputs?: Mk_Sec_Pg_F2_QInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Sec_Pg_F2_QInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_sec_pg_f2_q(inputs)
	return en_mk_sec_pg_f2_q(inputs)
});